module.exports = __webpack_public_path__ + "static/media/podcast.d05dc241.svg";